export default "__VITE_ASSET__BOxQrxWU__"